angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "INTRO": {
    "GUIDES": "{COUNT, plural, one{# local} other{# locals}}"
  }
}
);  }]);


//////////////////
// WEBPACK FOOTER
// ./webpack_loaders/nls.js!./app/src/components/translations/intro.json
// module id = 433
// module chunks = 24